import { useBrand } from '@contexts/index'

type Props = {
  preferenceType: string
}

const PreferenceTerms = ({ preferenceType }: Props) => {
  const brand = useBrand()

  const privacyLink =
    brand === 'lexus'
      ? 'https://www.lexus.co.uk/customer-data/lfs-privacy-policy'
      : 'https://www.toyota.co.uk/personal-finance/privacy-notice'

  return (
    <div className="my-8" data-gt-componentname="terms">
      <p>
        {preferenceType} is committed to protecting the privacy and security of
        personal information. We will use, store and share personal information
        for the purpose of providing and performing our products or services.
        Information about our use and handling of personal information, your
        data protection rights and how to contact us is provided in our{' '}
        <a
          className="underline whitespace-nowrap"
          href={privacyLink}
          target={'_blank'}
          rel={'noopener noreferrer'}
          data-gt-name="ctaevent"
          data-gt-action="terms-click-link"
          data-gt-label={privacyLink}
        >
          privacy notice
        </a>
        .
      </p>
    </div>
  )
}

export default PreferenceTerms
